import React, { useCallback, useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs } from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { useDropzone } from "react-dropzone";
import { db, storage } from "../firebase/firebase";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { v4 } from "uuid";
import { CircularProgressbar } from "react-circular-progressbar";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function EditWorkout() {
  const [name, setName] = useState("Laden...");
  const [muscleGrouop, setMuscleGroup] = useState(0);
  const [pulse, setPulse] = useState(0);
  const [desc, setDesc] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [mediaLink, setMediaLink] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingValue, setLoadingValue] = useState(0);
  const [uploadedData, setUploadedData] = useState(false);
  const [type, setType] = useState(0);
  const [isPublic, setIsPublic] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      }
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const onDrop = useCallback((acceptedFiles) => {
    setImageUpload(acceptedFiles[0]);
    uploadImage(acceptedFiles[0]);
  }, []);

  const navigate = useNavigate();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  const [imageUpload, setImageUpload] = useState(null);

  const uploadImage = async (data) => {
    var sendData = imageUpload;

    if (imageUpload == null && data == null) return;

    if (sendData == null) {
      sendData = data;
    }

    setIsLoading(true);

    var dataName = sendData.name + "_" + v4();

    const storage = getStorage();
    const storageRef = ref(storage, `exercises/${dataName}`);

    setMediaUrl(dataName);

    const uploadTask = uploadBytesResumable(storageRef, sendData);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setLoadingValue(progress);
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        alert("Fehler bei Hochladen: " + error);
      },
      () => {
        setUploadedData(true);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setMediaLink(downloadURL);
          console.log("File available at", downloadURL);
        });
      }
    );
  };

  const selPage = "workouts";

  function getExtension(path) {
    var basename = path.split(/[\\/]/).pop(),
      pos = basename.lastIndexOf(".");

    if (basename === "" || pos < 1) return "";

    basename = basename.slice(pos + 1);
    basename = basename.substring(0, 3);

    return basename;
  }

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^#]*)|#|$)"),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
    function getUrlVars() {
      return getParameterByName("workoutid");
    }

    const loadPlan = async () => {
      const q = query(
        collection(db, "exercise_templates"),
        where("__name__", "==", getUrlVars())
      );

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        setName(doc.data().name_de);
        setMuscleGroup(doc.data().muscle_group);
        setPulse(doc.data().hr_zone == undefined ? 0 : doc.data()?.hr_zone);
        setDesc(doc.data().desc_de);
        setTemplateId(doc.data().template_id);
        setMediaLink(doc.data().media_link);
        setMediaUrl(doc.data().media_url);
        setType(doc.data()?.type == undefined ? 0 : doc.data()?.type);
        setIsPublic(doc.data()?.isPublic);
      });
    };

    loadPlan();
  }, []);

  const ondeletePlan = async () => {
    const refPlan = doc(
      db,
      "exercise_templates",
      getParameterByName("workoutid")
    );

    await updateDoc(refPlan, {
      isActive: false,
    });

    window.location.replace("workouts");
  };

  function deletePlan() {
    window.confirm("Diese Übung wirklich löschen?") && ondeletePlan();
  }

  const onEditPlan = async () => {
    const refPlan = doc(
      db,
      "exercise_templates",
      getParameterByName("workoutid")
    );

    if (name != "" && desc != "" && templateId != "") {
      await updateDoc(refPlan, {
        name_de: name,
        desc_de: desc,
        template_id: templateId,
        muscle_group: muscleGrouop,
        media_link: mediaLink,
        media_url: mediaUrl,
        type: type,
        hr_zone: pulse,
        isPublic: isPublic ? isPublic : false,
      });

      alert("Gespeichert.");
    } else {
      alert("Bitte alle Daten angeben.");
    }
  };

  const Content = () => (
    <section className="home-section">
      <div className="text">Plan bearbeiten</div>

      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className="plan-data"
        id="plan-data"
      >
        <div className="container">
          <h2 id="plan-title">{name}</h2>
          <form className="contact-form">
            <p>Name:</p>

            <input
              type="search"
              className="plan-name"
              placeholder="Name"
              id="plan-name"
              value={name}
              onChange={(evt) => {
                setName(evt.target.value);
              }}
            />
            <p>Beschreibung</p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
            ></textarea>
            {/* <p>Kürzel</p>
            <input
              value={templateId}
              onChange={(evt) => {
                setTemplateId(evt.target.value);
              }}
              type="search"
              className="plan-type"
              placeholder="Ausdauer, Kraft..."
              id="plan-type"
            /> */}

            <p>Muskelgruppe</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={muscleGrouop}
              onChange={(evt) => {
                setMuscleGroup(Number(evt.target.value));
              }}
            >
              <option value="0">Ganzkörper</option>
              <option value="1">Brust</option>
              <option value="2">Rücken</option>
              <option value="3">Bauch</option>
              <option value="4">Beine</option>
            </select>

            <p>Pulsbereich</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={pulse}
              onChange={(evt) => {
                setPulse(Number(evt.target.value));
              }}
            >
              <option value="0">Keiner</option>
              <option value="1">Recom</option>
              <option value="2">GA 1</option>
              <option value="3">Ga 2</option>
              <option value="4">EB</option>
              <option value="5">SB</option>
            </select>

            <div style={{ height: 20 }}></div>

            {isAdmin && (
              <a
                style={{ cursor: "pointer", marginTop: 20 }}
                onClick={() => {
                  setIsPublic(!isPublic);
                }}
              >
                <div className="list-container">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid hsl(210, 14%, 83%)",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    className="list-item"
                  >
                    <p
                      style={{
                        padding: 2,
                        border: "1px solid hsl(210, 14%, 83%)",
                        marginRight: 15,
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ color: isPublic ? "#21252b" : "transparent" }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </p>
                    <p style={{ color: "#000", fontSize: 14 }}>
                      {"Öffentlich"}
                    </p>
                  </div>
                </div>
              </a>
            )}

            <p>Bild/Video</p>

            {mediaLink != "" ? (
              <>
                <FontAwesomeIcon
                  onClick={() => {
                    setMediaLink("");
                  }}
                  style={{
                    backgroundColor: "#7a3260",
                    padding: 5,
                    borderRadius: 999,
                    width: "15px",
                    height: "15px",
                    color: "#fff",
                    position: "absolute",
                    zIndex: 999,
                    marginTop: 10,
                    marginLeft: 10,
                    cursor: "pointer",
                  }}
                  icon={icon({ name: "close", style: "solid" })}
                />
                {getExtension(mediaLink) != "mp4" && (
                  <img style={{ width: "50%" }} src={mediaLink}></img>
                )}

                {getExtension(mediaLink) == "mp4" && (
                  <video width="50%" controls>
                    <source src={mediaLink} type="video/mp4" />
                  </video>
                )}
              </>
            ) : (
              <>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {uploadedData ? (
                    <>
                      <div
                        className={
                          "dropzone " + (isDragActive ? "active-dropzone" : "")
                        }
                        style={{ padding: 30 }}
                      >
                        <i
                          style={{
                            color: "#fff",
                            backgroundColor: "#7a3260",
                            borderRadius: 999,
                            padding: 10,
                          }}
                          className="fa-solid fa-check"
                        >
                          <FontAwesomeIcon
                            style={{ width: 60, height: 60 }}
                            icon={icon({ name: "check", style: "solid" })}
                          />
                        </i>
                        <span>{imageUpload.name}</span>
                      </div>
                    </>
                  ) : isLoading ? (
                    <div
                      className={
                        "dropzone " + (isDragActive ? "active-dropzone" : "")
                      }
                      style={{ padding: 30 }}
                    >
                      <CircularProgressbar value={loadingValue} />
                      <span>Datei wird hochgeladen...</span>
                    </div>
                  ) : (
                    <>
                      <div
                        className={
                          "dropzone " + (isDragActive ? "active-dropzone" : "")
                        }
                      >
                        <span>Drag and Drop</span>
                        <span>oder</span>
                        <label htmlFor="dropzoneFile">Datei auswählen</label>
                        <input
                          onChange={(evt) => {
                            setImageUpload(evt.target.files[0]);
                            uploadImage(evt.target.files[0]);
                          }}
                          type="file"
                          id="dropzoneFile"
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </form>

          <div className="form-button">
            <div style={{ display: "flex" }}>
              <button
                onClick={() => onEditPlan()}
                className="btn submit-form"
                type="submit"
              >
                Speichern
              </button>
              <div style={{ width: 10 }}></div>

              <button
                onClick={() => navigate(-1)}
                className="btn btn-gray submit-form"
                type="submit"
              >
                Abbrechen
              </button>
              <div style={{ width: 10 }}></div>
            </div>

            <button
              onClick={() => deletePlan()}
              className="btn btn-red submit-form"
              type="submit"
            >
              Löschen
            </button>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
